import { useSyncExternalStore } from "react";

/**
 * From the Tafo app to the till on the owner's phone and back, without loading the page again (Furkan,
 * 18/10/2026: between Ober and Kassa the screen flashed, white and then the red of the app behind the page,
 * while a new page loaded). The address changes and the screen is drawn anew in the same page.
 */
const EVENT = "tafo:screen";

export function switchScreen(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState(null, "", path);
  window.dispatchEvent(new Event(EVENT));
}

/** Whether the address is the Tafo app (/app); the till otherwise. Follows switchScreen and the back button. */
export function useInTafoApp(): boolean {
  return useSyncExternalStore(
    (changed) => {
      window.addEventListener(EVENT, changed);
      window.addEventListener("popstate", changed);
      return () => {
        window.removeEventListener(EVENT, changed);
        window.removeEventListener("popstate", changed);
      };
    },
    () => isTafoAppPath(window.location.pathname),
  );
}

export const isTafoAppPath = (pathname: string): boolean => /^\/app\/?$/.test(pathname);
